module.exports = __webpack_public_path__ + "img/icon_map_62_on_100.1e810bb4.png";